import React from "react";
import styles from "./FinUpdateCompleted.module.scss";
import DoneImage from "../../../Components/assets/Images/congratsdoneimage.svg";

function FinUpdationApproved() {
  const next_update: any = sessionStorage.getItem("next_update");
  return (
    <div className={styles.mainWrapperTop}>
      <div className={styles.wrapper}>
        <div className={styles.step}>
          <img src={DoneImage} />
        </div>
        <div className={styles.leftContainer}>
          <div className={styles.headerSection}>
            <p className={styles.signup}>Financial Details are up to date</p>
            <div className={styles.textdiv}>
              <p className={styles.instructiontext}>
                Your financial document is currently up to date. The next update
                is scheduled for {next_update}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default FinUpdationApproved;
